import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/industries/education')({
  head: () => ({
    ...buildSeoHead({ path: '/industries/education', ...ROUTE_META['/industries/education'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Industries', path: '/industries' }, { name: 'Education', path: '/industries/education' }])),
      jsonLdScript(buildWebPageSchema({ path: '/industries/education', ...ROUTE_META['/industries/education'] })),
    ],
  }),
});
